import API from '../../../../../services/api';

export const INCIDENCIA_STEP_LOGS_API = {
    new: async (steps) => {
        return API.post('/incidencia_steps_logs', steps).then(res => res.data);
    }
}